import { useTranslation } from 'react-i18next';
import { Wallet } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useMyCpmWalletQuery } from '@/generated/graphql';
import { formatCents } from '@/lib/format';

export function SidebarWalletCard() {
  const { t } = useTranslation();
  const { data, loading } = useMyCpmWalletQuery({
    fetchPolicy: 'cache-and-network',
  });

  if (loading || !data?.myCpmWallet) return null;

  const wallet = data.myCpmWallet;
  if (wallet.available_cents <= 0) return null;

  return (
    <div className="flex flex-col gap-1.5 p-2.5 bg-emerald-500/5 border border-emerald-500/20 rounded-lg mx-2">
      <div className="flex items-center gap-1.5">
        <Wallet className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" />
        <span className="text-[11px] font-medium text-muted-foreground">
          {t('campaign.wallet.title')}
        </span>
      </div>
      <div className="text-lg font-bold leading-tight">
        {formatCents(wallet.available_cents, 'BRL')}
      </div>
      <Button
        asChild
        size="sm"
        className="w-full h-7 text-xs bg-emerald-400 hover:bg-emerald-500 text-emerald-950 font-semibold"
      >
        <Link to="/earn/wallet">{t('campaign.wallet.requestButton')}</Link>
      </Button>
    </div>
  );
}
